// Build-Info wird zur Build-Zeit von Vite injiziert
declare const __BUILD_INFO__: { app: string; wave: string; builtAt: string };

export const buildInfo = __BUILD_INFO__;

/**
 * Bamoa Debug-Helper — verfügbar als window.bamoa
 * Zugriff: F12 Console, `bamoa.debug()` für Snapshot, `bamoa.version` für Build-Info
 */
export function installDebugHelper(extras: Record<string, unknown> = {}) {
  (window as any).bamoa = {
    version: buildInfo,
    verbose(on = true) {
      try {
        if (on) localStorage.setItem('bamoa_debug', '1');
        else localStorage.removeItem('bamoa_debug');
      } catch { /* ignore */ }
      console.log(`%cBamoa Debug-Modus ${on ? 'AKTIV — ausführliche Logs' : 'aus'}`, 'color:#fff;background:#b45309;padding:2px 6px;border-radius:3px;font-weight:bold');
      console.log('Hinweis: gilt ab dem nächsten Call / Reload.');
      return on;
    },
    debug() {
      const token = localStorage.getItem('bamoa_token');
      const snap = {
        build: buildInfo,
        debugMode: localStorage.getItem('bamoa_debug') === '1',
        loggedInAs: {
          userId: localStorage.getItem('bamoa_user_id'),
          userName: localStorage.getItem('bamoa_user_name'),
          tenantId: localStorage.getItem('bamoa_tenant_id'),
          tokenPresent: !!token,
          tokenLength: token?.length ?? 0,
        },
        url: window.location.href,
        userAgent: navigator.userAgent,
        ...extras,
      };
      console.log('%c━━━ Bamoa Debug Snapshot ━━━', 'font-weight:bold;color:#666');
      console.table(snap.build);
      console.table(snap.loggedInAs);
      console.log('Full snapshot:', snap);
      return snap;
    },
    async backendState() {
      const t = localStorage.getItem('bamoa_token');
      if (!t) return { error: 'not logged in' };
      const res = await fetch('/api/debug/state', {
        headers: { Authorization: `Bearer dev:${t}` },
      });
      const data = await res.json();
      console.log('%c━━━ Backend State ━━━', 'font-weight:bold;color:#666');
      console.log(data);
      return data;
    },
  };
  console.log(
    `%cBamoa ${buildInfo.app} · Welle ${buildInfo.wave} · ${buildInfo.builtAt}`,
    'color:#fff;background:#000;padding:2px 6px;border-radius:3px;font-weight:bold',
  );
  console.log('Debug-Helper verfügbar: bamoa.debug(), bamoa.backendState(), bamoa.verbose(true), bamoa.version');
}
